"use client";

const matches = [
  "Brasil x Servia",
  "Brasil x Senegal",
  "Brasil x Holanda",
  "Oitavas com Brasil",
  "Quartas com Brasil",
  "Final",
];

export default function Games() {
  return (
    <section
      className="games-section reveal-up lg:min-h-lvw min-h-screen"
      id="programacao"
    >
      <div
        // className="section-container games-content"
        className="flex justify-center flex-col"
      >
        <div className=" lg:pt-10 pl-5 pt-10">
          <div
            className="text-[#2033ef] border-[#2033ef] w-fit p-4"
            style={{ borderWidth: 1, marginBottom: 20 }}
          >
            <div
              className="flex flex-row gap-2 items-center font-bold text-[11px]"
              style={{
                paddingLeft: 6,
                paddingRight: 6,
                paddingTop: 0,
                paddingBottom: 0,
                height: 5,
              }}
            >
              <div className="h-2 w-2 rounded-full bg-[#FEC822]" />{" "}
              <p>ACOMPANHE A PROGRAMAÇÃO</p>
            </div>
          </div>

          <h1 className="font-extrabold text-[#2033ef] text-[34px]">
            PROGRAMAÇÃO
          </h1>
        </div>

        <iframe
          // src={`http://localhost:3001/partida/?date=${new Date().toISOString()}&city=SP`}
          src="https://tm1-copa.vercel.app"
          className="w-[100%] h-full lg:min-h-[103lvw] min-h-screen"
        />
      </div>

      <style jsx>{`
        .games-section {
          min-height: 560px;
          // background: var(--brand-blue);
          background: white;
          padding: 64px 0 64px;
          color: white;
          scroll-margin-top: 6.5rem;
        }

        .games-content {
          display: grid;
          justify-items: center;
          gap: 26px;
          text-align: center;
        }

        .games-content h2 {
          max-width: 760px;
        }

        .games-content p {
          max-width: 560px;
          line-height: 1.7;
          font-size: 16px;
        }

        .match-list {
          width: min(720px, 100%);
          display: grid;
          gap: 10px;
          margin: 12px 0 38px;
        }

        .match-item {
          min-height: 52px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          border-bottom: 1px solid rgba(254, 200, 34, 0.38);
          color: var(--brand-yellow);
          text-transform: uppercase;
        }

        .match-item span {
          font-weight: 950;
          color: white;
          opacity: 0.75;
        }

        .match-item strong {
          font-size: clamp(18px, 4vw, 32px);
          line-height: 1;
          font-weight: 950;
          text-align: right;
        }

        @media (max-width: 640px) {
          .games-section {
            padding: 52px 0 60px;
          }

          .match-item {
            align-items: flex-start;
            flex-direction: column;
            padding: 12px 0;
          }

          .match-item strong {
            text-align: left;
          }
        }
      `}</style>
    </section>
  );
}
